import register         from '../../register';
import $                from 'jquery';
import FormSequence     from '../classes/form-sequence';
import preorder_email   from '../steps/preorder-email/step';
import preorder_payment from '../steps/preorder-payment/step';
import preorder_success from '../steps/preorder-success/step';

export default register( 'preorder', () => {

  const sequence = new FormSequence({
    $el: $('.signup-container'),
    first: 'preorder_email',
    events: {
      showStep: 'trackStep'
    },
    configs: {
      preorder_email: {
        step: preorder_email,
        next: 'preorder_payment',
        nextText: 'Get Started',
        hideBackButton: true
      },
      preorder_payment: {
        step: preorder_payment,
        next: null,
        submitText: 'Get early access',
        hideBackButton: true
      },
      preorder_success: {
        step: preorder_success,
        next: null,
        hideControls: true
      }
    },
    state: { gis_id: window.gis_id, gis_address: window.gis_address },
    submit() {
      const url = '/preorder';

      const data = Object.assign( {}, this.store.getState() );
      const btn  = this.$el.find( this.submitSelector );

      // fix issue where entering a unit # and then deleting it fails
      // cloud-api validation, which allows null but not empty strings
      if ( data.unit === '' ) {
        data.unit = null;
      }

      btn.addClass('loading');

      $.ajax({
        method: 'POST',
        url,
        contentType: 'application/json',
        data: JSON.stringify( data ),
        success( user ) {
          sequence.onSuccess( user );
        },
        complete() {
          btn.removeClass('loading');
        },
        error( xhr ) {
          let msg = 'Something went wrong. Please try again.';

          try {
            const json = JSON.parse( xhr.responseText );
            if ( json.stripe_message ) {
              msg = json.stripe_message;
            }
          } catch ( e ) {}

          preorder_payment.showCardError( msg );
        }
      });
    },
    onSuccess() {
      sequence.showStep('preorder_success');
    },
    trackStep( name, conf ) {
      window.dataLayer = window.dataLayer || [];

      const state = this.store.getState() || {};

      window.dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': `/preorder/${ name }`,
        'virtualPageTitle': conf.title || name,
        'gis_id': state.gis_id
      });

      if ( window.acumen && window.acumen.track ) {
        const meta = {
          view: name,
          title: conf.title || name,
          gis_id: state.gis_id
        };

        if ( typeof conf.trackingData === 'function' ) {
          Object.assign( meta, conf.trackingData() );
        }

        window.acumen.track( 'virtual-pageview',  meta );
      }
    }
  });

  window.sequence = sequence;

});
